var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlackActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 189,
    viewBox: "0 0 307 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slack",
    filter: "url(#filter0_d_4872_45943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 250,
    height: 131,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24.5,
    width: 249,
    height: 130,
    rx: 9.5,
    stroke: "#3A3A3A",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120.313 100.372L122.313 95.7144C124.474 97.3315 127.345 98.1724 130.183 98.1724C132.279 98.1724 133.602 97.3638 133.602 96.1348C133.569 92.7066 121.055 95.391 120.959 86.788C120.926 82.4219 124.797 79.0583 130.279 79.0583C133.537 79.0583 136.794 79.8669 139.117 81.7104L137.246 86.4646C135.117 85.1063 132.473 84.136 129.957 84.136C128.248 84.136 127.119 84.9446 127.119 85.9795C127.151 89.343 139.762 87.4996 139.891 95.7144C139.891 100.178 136.117 103.315 130.699 103.315C126.732 103.315 123.087 102.377 120.313 100.372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M197.041 94.0326C196.041 95.7791 194.171 96.9757 192.01 96.9757C188.817 96.9757 186.237 94.3884 186.237 91.1865C186.237 87.9847 188.817 85.3973 192.01 85.3973C194.171 85.3973 196.041 86.594 197.041 88.3404L202.556 85.268C200.492 81.581 196.525 79.0583 192.01 79.0583C185.333 79.0583 179.915 84.4918 179.915 91.1865C179.915 97.8813 185.333 103.315 192.01 103.315C196.557 103.315 200.492 100.824 202.556 97.1051L197.041 94.0326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M149.566 69H142.664V102.862H149.566V69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M205.268 69V102.862H212.17V92.7065L220.362 102.862H229.199L218.781 90.7984L228.425 79.5434H219.975L212.17 88.8902V69H205.268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M170.079 94.0973C169.079 95.7467 167.015 96.9757 164.693 96.9757C161.5 96.9757 158.919 94.3884 158.919 91.1865C158.919 87.9847 161.5 85.3973 164.693 85.3973C167.015 85.3973 169.079 86.691 170.079 88.3728V94.0973ZM170.079 79.5435V82.2925C168.95 80.3844 166.144 79.0583 163.209 79.0583C157.145 79.0583 152.372 84.4271 152.372 91.1542C152.372 97.8813 157.145 103.315 163.209 103.315C166.144 103.315 168.95 101.989 170.079 100.081V102.83H176.981V79.5435H170.079Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M77.6272 94.9188C77.6272 97.3017 75.7066 99.2277 73.3302 99.2277C70.9538 99.2277 69.0332 97.3017 69.0332 94.9188C69.0332 92.5358 70.9538 90.6099 73.3302 90.6099H77.6272V94.9188Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M79.7764 94.9188C79.7764 92.5358 81.697 90.6099 84.0734 90.6099C86.4498 90.6099 88.3704 92.5358 88.3704 94.9188V105.691C88.3704 108.074 86.4498 110 84.0734 110C81.697 110 79.7764 108.074 79.7764 105.691V94.9188Z",
    fill: "#E01E5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M84.0724 77.6178C81.696 77.6178 79.7754 75.6919 79.7754 73.3089C79.7754 70.926 81.696 69 84.0724 69C86.4488 69 88.3694 70.926 88.3694 73.3089V77.6178H84.0724Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M84.0721 79.8049C86.4485 79.8049 88.3691 81.7309 88.3691 84.1139C88.3691 86.4968 86.4485 88.4228 84.0721 88.4228H73.297C70.9206 88.4228 69 86.4968 69 84.1139C69 81.7309 70.9206 79.8049 73.297 79.8049H84.0721Z",
    fill: "#36C5F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M101.292 84.1139C101.292 81.7309 103.213 79.8049 105.589 79.8049C107.965 79.8049 109.886 81.7309 109.886 84.1139C109.886 86.4968 107.965 88.4228 105.589 88.4228H101.292V84.1139Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M99.1438 84.1139C99.1438 86.4968 97.2232 88.4228 94.8468 88.4228C92.4704 88.4228 90.5498 86.4968 90.5498 84.1139V73.3089C90.5498 70.926 92.4704 69 94.8468 69C97.2232 69 99.1438 70.926 99.1438 73.3089V84.1139Z",
    fill: "#2EB67D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M94.8478 101.382C97.2242 101.382 99.1448 103.308 99.1448 105.691C99.1448 108.074 97.2242 110 94.8478 110C92.4714 110 90.5508 108.074 90.5508 105.691V101.382H94.8478Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M94.8478 99.2277C92.4714 99.2277 90.5508 97.3017 90.5508 94.9188C90.5508 92.5358 92.4714 90.6099 94.8478 90.6099H105.623C107.999 90.6099 109.92 92.5358 109.92 94.9188C109.92 97.3017 107.999 99.2277 105.623 99.2277H94.8478Z",
    fill: "#ECB22E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 193",
    d: "M274 46.7964V145C274 150.523 269.523 155 264 155H34C28.4772 155 24 150.523 24 145V35C24 29.4772 28.4772 25 34 25H241.5",
    stroke: "#11A371",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 57"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 75",
    cx: 257.5,
    cy: 39.5,
    r: 21.5,
    fill: "white",
    stroke: "#11A371",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M268.185 31.9969L268.185 31.9962C268.228 31.9535 268.278 31.9197 268.334 31.8966C268.39 31.8735 268.449 31.8616 268.509 31.8616C268.57 31.8616 268.629 31.8735 268.685 31.8966C268.74 31.9197 268.791 31.9535 268.833 31.9962L268.835 31.9973C268.877 32.0398 268.911 32.0903 268.934 32.1459C268.957 32.2015 268.969 32.261 268.969 32.3212C268.969 32.3814 268.957 32.441 268.934 32.4965C268.911 32.5521 268.877 32.6026 268.835 32.6451L268.834 32.6455L255.604 45.8723C255.158 46.3177 254.554 46.5679 253.923 46.5679C253.293 46.5679 252.688 46.3177 252.242 45.8723L247.124 40.7551L247.123 40.7544C247.08 40.7119 247.046 40.6614 247.023 40.6058L246.562 40.7976L247.023 40.6058C247 40.5502 246.988 40.4905 246.988 40.4303C246.988 40.3701 247 40.3105 247.023 40.2548C247.046 40.1992 247.08 40.1487 247.123 40.1062L247.124 40.1048C247.167 40.0621 247.217 40.0283 247.273 40.0052C247.329 39.9821 247.388 39.9702 247.448 39.9702C247.509 39.9702 247.568 39.9821 247.624 40.0052C247.679 40.0283 247.73 40.0621 247.772 40.1048L247.773 40.1053L252.889 45.2262C252.889 45.2263 252.889 45.2264 252.889 45.2265C253.025 45.3623 253.186 45.4701 253.363 45.5436C253.54 45.6172 253.73 45.6551 253.922 45.6551C254.114 45.6551 254.304 45.6172 254.481 45.5436C254.658 45.4701 254.819 45.3623 254.954 45.2265C254.954 45.2264 254.954 45.2263 254.954 45.2262L268.185 31.9969Z",
    fill: "black",
    stroke: "#11A371"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4872_45943",
    x: 0,
    y: 0,
    width: 307,
    height: 189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.392157 0 0 0 0 0.462745 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4872_45943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4872_45943",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackActive);
export default __webpack_public_path__ + "static/media/slackActive.3de02964200feae636322907e9d19cc6.svg";
export { ForwardRef as ReactComponent };